import { Download } from "lucide-react";
import { useTranslation } from "react-i18next";

import Folder from "@/assets/common/other_icons/folder.svg?react";
import useSegmentEvent from "@/hooks/useSegmentEvent";

import BaseCard, { ActionButton } from "./BaseCard";

type DownloadFootprintAnalysisProps = {
  url?: string;
};

function DownloadFootprintAnalysis({ url }: DownloadFootprintAnalysisProps) {
  const { t } = useTranslation("communicate");
  const { sendSegmentEvent } = useSegmentEvent();

  return (
    <BaseCard
      title={t("downloadFootprintAnalysis.title")}
      text={t("downloadFootprintAnalysis.text")}
      Icon={Folder}
      tag="new"
    >
      <ActionButton
        to={url}
        onClick={() => sendSegmentEvent("pdf_restitution_downloaded")}
        shouldOpenNewTab
      >
        <Download />
        {t("downloadFootprintAnalysis.cta")}
      </ActionButton>
    </BaseCard>
  );
}

export default DownloadFootprintAnalysis;
